var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        transition: false,
        persistent: _vm.pending,
        "max-width": _vm.maxWidth,
      },
      on: {
        "click:outside": function ($event) {
          !_vm.pending ? _vm.cancel() : () => {}
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("MediaFileLoader", {
        attrs: { "file-type": _vm.fileType },
        on: {
          "files-uploaded": _vm.upload,
          "close-dialog": _vm.close,
          "update-grid": function ($event) {
            return _vm.$emit("update-grid")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }